import {styled} from "@mui/system";
import {Button, Grid, Paper, Stepper, Table, TableCell, TableContainer, TableRow, Typography} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import React from "react";

export const Orange = '#e74011';
export const Black = '#282828';
export const Gray = '#D6DAD4';
export const BlackWithOpacity = 'rgba(40, 40, 40, 0.3)';
export const White = '#EDEDED';
export const DateFormat = 'DD/MM/YYYY';

export const StyledButtonContainer = styled(Grid)`
  margin-top: 1rem;
  padding: 5px;
  grid-gap: 10px; /* Adjust the value as per your desired spacing */
`;

export const StyledButtonNoColor = styled(Button)`
  color: ${Black};
  background-color: ${Gray};
  &:hover {
    background-color: ${BlackWithOpacity};
  }
`;

export const StyledButtonOrange = styled(Button)`
  color: ${White};
  background-color: ${Orange};
  &:hover {
    background-color: ${Black};
  }
`;

export const StyledButtonWhite = styled(Button)`
  color: ${Black};
  background-color: ${White};
  &:hover {
    background-color: ${BlackWithOpacity};
  }
`;

export const StyledButtonBlack = styled(Button)`
  color: ${White};
  background-color: ${Black};
  &:hover {
    background-color: ${Orange};
  }
`;

export const StyledTabPanel = styled(TabPanel)`
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1rem;
  }

  th,
  td {
    padding: 8px 0 8px 8px;
    border-bottom: 1px solid #ccc;
    text-align: left;
    vertical-align: top;
  }
`;

function TabPanel({ value, index, children }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index && <div>{children}</div>}
        </div>
    );
}

export const StyledTable = styled(Table)`
  border-collapse: collapse;
  width: 100%;
`;

export const StyledTableHeadRow = styled(TableRow)`
  background-color: #f5f5f5;
  font-weight: bold;
`;

export const StyledTableCell = styled(TableCell)`
  padding: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid #ccc;
  padding-left: 8px;
`;

export const StyledTableCellHeader = styled(TableCell)`
  padding: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid #ccc;
  padding-left: 8px;
  font-weight: bold;
  width: ${(props) => props.columncount ? `${100 / props.columncount}%` : 'auto'};
`;


export const StyledTableBodyRow = styled(TableRow)`
  &:nth-of-type(even) {
    background-color: #f9f9f9;
  }
  &:hover {
    background-color: #ebebeb;
    cursor: pointer;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  margin-top: 1rem;
`;

export const StyledStepper = styled(Stepper)`
  margin-top: 1rem;
`;

export const StyledAlert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const MyDashboardItemGray = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${Gray};
  max-height: 525px;
  overflow-y: auto;
`;

export const MyDashboardItemGrayClickable = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${Gray};
  max-height: 525px;
  overflow-y: auto;

  &:hover {
    background-color: ${BlackWithOpacity};
    cursor: pointer;
  }
`;

export const MyDashboardItemWhite = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${White};
  margin-top: 10px;
  
  &:hover {
    background-color: ${BlackWithOpacity};
    cursor: pointer;
  }
`;

export const MyDashboardItemPropsColor = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${(props) => props.color};
  margin-top: 10px;
  
  &:hover {
    background-color: ${BlackWithOpacity};
    cursor: pointer;
  }
`;

export const MyDashboardTypography = styled(Typography)`
  margin-left: 10px;
`;